import React, { useEffect, useState } from 'react';
import {
  Overlay, Card, Title, RingWrap,
} from './FastQuoteLoading.styles';

const START = 45;
const RADIUS = 42;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export function FastQuoteLoading() {
  const [counter, setCounter] = useState(START);

  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const value = Math.max(counter, 0);
  const dashoffset = CIRCUMFERENCE * (1 - value / START);

  return (
    <Overlay>
      <Card>
        <Title>Attendi, stiamo cercando i dati…</Title>
        <RingWrap>
          <svg viewBox="0 0 96 96" width="96" height="96">
            <circle className="track" cx="48" cy="48" r={RADIUS} fill="none" strokeWidth="6" />
            <circle
              className="progress"
              cx="48"
              cy="48"
              r={RADIUS}
              fill="none"
              strokeWidth="6"
              strokeDasharray={CIRCUMFERENCE}
              strokeDashoffset={dashoffset}
            />
          </svg>
          <span className="value">{value}</span>
        </RingWrap>
      </Card>
    </Overlay>
  );
}
